import { CalendarPermissions } from '@principle-theorem/principle-core/features';
import {
  EventType,
  type Permission,
} from '@principle-theorem/principle-core/interfaces';

/**
 * `isManagedCalendarEventType` in `apps/principle-functions/firestore.rules`
 * repeats these types, and the rules spec derives its cases from this map so
 * the two cannot drift apart unnoticed.
 */
export const CALENDAR_EVENT_TYPE_PERMISSIONS: Partial<
  Record<EventType, Permission>
> = {
  [EventType.Meeting]: CalendarPermissions.CalendarEventsManage,
  [EventType.PreBlock]: CalendarPermissions.CalendarEventsManage,
  [EventType.Break]: CalendarPermissions.CalendarEventsManage,
  [EventType.Leave]: CalendarPermissions.CalendarEventsManage,
  [EventType.Misc]: CalendarPermissions.CalendarEventsManage,
  [EventType.PracticeClosed]: CalendarPermissions.CalendarEventsManage,
};
